import { createAsyncThunk } from "@reduxjs/toolkit";
import { getCustomerDesignStart, getCustomerDesignSuccess, getCustomerDesignFailure } from "../Reducer/getCustomerDesignReducer.js";
import axios from "axios";
import { getBaseUrl } from "../../utils";

export const getCustomerDesign = createAsyncThunk(
  "getCustomerDesign",
  async (id, thunkAPI) => {
    try {
      thunkAPI.dispatch(getCustomerDesignStart());

      const response = await axios.get(`${getBaseUrl()}SingleDesign/${id}`);

      const responseData = await response;

      thunkAPI.dispatch(getCustomerDesignSuccess(responseData?.data.data));

      return responseData;
    } catch (error) {
      thunkAPI.dispatch(getCustomerDesignFailure(error.response.data.message));

      throw error;
    }
  },
);
